import { ICellRendererParams } from "ag-grid-community";
import _ from "lodash";
import { TenantService } from "projects/shared/src/lib/services/tenant.service";
import { TranslateService } from "projects/shared/src/lib/services/translate.service";

export class AgGridUsersSettings {

  constructor(private translate: TranslateService, private tenantService: TenantService, private deletable: boolean) { }

    public agGridUsersSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      //{ field: 'userName', headerName: `${this.translate.data["USERSUSERNAMECOLUMNHEADER"]}`, sortable: false, filter: true },
      { field: 'last_Name', headerName: `${this.translate.data["USERSLASTNAMECOLUMNHEADER"]}`, sortable: true, filter: true },
      { field: 'first_Name', headerName: `${this.translate.data["USERSFIRSTNAMECOLUMNHEADER"]}`, sortable: false, filter: false },
      { field: 'email', headerName: `${this.translate.data["USERSEMAILCOLUMNHEADER"]}`, sortable: false, filter: false },
      { field: 'phoneNumber', headerName: `${this.translate.data["USERSPHONENUMBERCOLUMNHEADER"]}`, sortable: false, filter: false },
      // {
      //   headerName: `${this.translate.data["USERSDEMOFLAG"]}`,
      //   cellRenderer: 'flagRenderer',
      //   cellRendererParams: {
      //     icon_check: 'check',
      //   },
      //   sortable: false,
      //   filter: false
      // },
      {
        width: 430,
        headerName: `${this.translate.data["USERSACTIONSCOLUMNHEADER"]}`,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_edit: 'edit',
          icon_view: 'visibility',
          icon_delete: (this.deletable)?'delete':'',
          // routerLinkEditUser: (params: ICellRendererParams) => `/user-proflie/${_.get(params, 'data.id')}`,
          routerLinkEditUser: (params: ICellRendererParams) => `/user-profile/${_.get(params, 'data.id')}`,
          routerLinkViewUser: (params: ICellRendererParams) => `/${this.tenantService.currentTenantName}/manage-users/${_.get(params, 'data.id')}`
        },
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }

}